export const SITE_URL = 'https://puremedify.com';

export interface SiteMapLink {
  path: string;
  label: string;
  description: string;
}

export interface SiteMapSection {
  id: string;
  title: string;
  description: string;
  links: SiteMapLink[];
}

export const NAV_LINKS: SiteMapLink[] = [
  { path: '/', label: 'Home', description: 'Overview of PureMedify, our mission, and key services.' },
  { path: '/about', label: 'About', description: 'Our story, values, and purpose-driven healthcare vision.' },
  { path: '/services', label: 'Services', description: 'Healthcare, wellness, charity, and community offerings.' },
  { path: '/news', label: 'News', description: 'Latest updates, campaigns, and project announcements.' },
  { path: '/team', label: 'Team', description: 'Meet our leadership and operational team.' },
  { path: '/partnerships', label: 'Partnerships', description: 'Collaborations with NGOs, government, and private sector.' },
  { path: '/careers', label: 'Careers', description: 'Open roles and opportunities to join our mission.' },
  { path: '/community', label: 'Community', description: 'Impact programs, outreach, and social initiatives.' },
  { path: '/contact', label: 'Contact', description: 'Reach us for appointments, support, or partnerships.' },
  { path: '/sitemap', label: 'Sitemap', description: 'Full overview of all pages and sections on this site.' },
];

export const SITE_MAP_SECTIONS: SiteMapSection[] = [
  {
    id: 'main',
    title: 'Main Pages',
    description: 'Core pages across the PureMedify website.',
    links: NAV_LINKS.filter((link) => link.path !== '/sitemap'),
  },
  {
    id: 'services',
    title: 'Services & Programs',
    description: 'Key service areas delivered through PureMedify and partners.',
    links: [
      {
        path: '/great-emmanuel-hospital',
        label: 'The Great Emmanuel Hospital',
        description: 'Our founding hospital — story, legacy, and medical services in Umunneochi, Abia State.',
      },
      {
        path: '/services',
        label: 'Charity & Foundation',
        description: 'PureMedify Foundation programs for underserved communities, women, and children.',
      },
      {
        path: '/services',
        label: 'Lifestyle & Wellness',
        description: 'Organic cosmetics, spa, boutique, and wellness products.',
      },
      {
        path: '/services',
        label: 'Technology & Logistics',
        description: 'Digital solutions, eCommerce, logistics, and infrastructure services.',
      },
      {
        path: '/services',
        label: 'Agro-Allied & Food Security',
        description: 'Farming, agribusiness, and food security initiatives.',
      },
    ],
  },
  {
    id: 'support',
    title: 'Patient & Visitor Support',
    description: 'Quick paths for care, emergencies, and getting in touch.',
    links: [
      {
        path: '/contact',
        label: 'Book an Appointment',
        description: 'Schedule a visit or request medical support.',
      },
      {
        path: '/contact',
        label: 'Call a Doctor',
        description: 'Speak with a medical professional or request a consultation.',
      },
      {
        path: '/contact',
        label: 'Emergency & Ambulance',
        description: 'Urgent care and emergency response contact options.',
      },
      {
        path: '/contact',
        label: 'Contact Information',
        description: 'Address, email, phone, and social media channels.',
      },
    ],
  },
  {
    id: 'impact',
    title: 'Impact & Engagement',
    description: 'Learn about our work and ways to collaborate.',
    links: [
      {
        path: '/community',
        label: 'Community Impact',
        description: 'Health education, women empowerment, and mobile clinics.',
      },
      {
        path: '/partnerships',
        label: 'Partnerships & Projects',
        description: 'NGO, government, and private sector collaborations.',
      },
      {
        path: '/news',
        label: 'News & Updates',
        description: 'Stories from our clinics, CSR work, and telemedicine expansion.',
      },
      {
        path: '/careers',
        label: 'Careers',
        description: 'Join our team in healthcare, outreach, and technology.',
      },
    ],
  },
  {
    id: 'hospital',
    title: 'The Great Emmanuel Hospital',
    description: 'Our founding healthcare institution — from loss to legacy.',
    links: [
      {
        path: '/great-emmanuel-hospital',
        label: 'Hospital Story & Legacy',
        description: 'The vision, history, and impact of The Great Emmanuel Hospital Limited.',
      },
      {
        path: '/contact',
        label: 'Book an Appointment',
        description: 'Schedule a visit or request medical support at the hospital.',
      },
    ],
  },
];

export const XML_SITEMAP_PATHS = [...NAV_LINKS.map((link) => link.path), '/great-emmanuel-hospital'];

export const SERVICES_DROPDOWN_LINKS: SiteMapLink[] = [
  {
    path: '/services',
    label: 'All Services',
    description: 'Healthcare, wellness, charity, and community offerings.',
  },
  {
    path: '/great-emmanuel-hospital',
    label: 'Great Emmanuel Hospital',
    description: 'Our founding hospital — story, legacy, and medical services in Umunneochi, Abia State.',
  },
];
